import LoginPage from '@/features/auth/routes/LoginPage'
import NewPasswordPage from '@/features/auth/routes/NewPasswordPage'
import RequestPasswordResetPage from '@/features/auth/routes/RequestPasswordResetPage'

const authRoutes = [
  {
    breadcrumb: 'Login',
    path: '',
    element: <LoginPage />,
  },
  {
    breadcrumb: 'Login',
    path: 'auth/login',
    element: <LoginPage />,
  },
  {
    breadcrumb: 'Request Password Reset',
    path: 'auth/requestPasswordReset',
    element: <RequestPasswordResetPage />,
  },
  {
    breadcrumb: 'Password Reset',
    path: 'auth/newPassword',
    element: <NewPasswordPage />,
  },
]

export default authRoutes
